import axios from 'axios';
import querystring from 'querystring';

import { fdApiUse } from '../apiUtils';
import {
  FulfilmentStatus,
  GetFulfilmentStatusQueryParams,
  GetOrderHistoryQueryParams,
  GetReorderQueryParams,
  GetReordersQueryParams,
  OrderHistory,
  Reorder,
} from './order.types';

// #region get requests
export const getFulfilmentStatus = (
  queryParams: GetFulfilmentStatusQueryParams,
): Promise<FulfilmentStatus> =>
  fdApiUse(axios.get('/order/fulfillmentstatus', { params: queryParams })).then(
    (data: FulfilmentStatus) => data,
  );

export const getOrderHistory = (
  queryParams: GetOrderHistoryQueryParams,
): Promise<OrderHistory[]> =>
  fdApiUse(axios.get('/orderhistory/orders', { params: queryParams })).then(
    (data: OrderHistory[]) => data,
  );

export const getReorder = (
  queryParams: GetReorderQueryParams,
): Promise<Reorder> =>
  fdApiUse(
    axios.get('/OrderSuggestions/ReOrderById', {
      params: queryParams,
    }),
  ).then((data: Reorder) => data);

export const getReorders = (
  queryParams: GetReordersQueryParams,
): Promise<Reorder[]> =>
  fdApiUse(
    axios.get('/OrderSuggestions/ReOrderList', {
      params: queryParams,
      paramsSerializer: (params) => querystring.stringify(params),
    }),
  ).then((data: Reorder[]) => data);
// #endregion
